export default __webpack_public_path__ + "static/media/educa+2-removebg-preview.64c02544.png";